import { tvgColorPalette as colors } from "@tvg/design-system/src/theming/themes/common/tvgColorPalette";
import styled, { css } from "styled-components";

export default styled.div<{ nonNumeric?: boolean; isWinner?: boolean }>`
  display: flex;
  font-size: 14px;
  font-style: normal;
  ${({ nonNumeric, isWinner, theme }) =>
    nonNumeric
      ? css`
          font-family: ${theme.fonts.medium};
          font-weight: 500;
          line-height: 19px;
          color: ${theme.colorTokens.content.default};
        `
      : css`
          font-family: ${theme.fonts.bold};
          font-weight: 700;
          line-height: 22px;
          color: ${isWinner
            ? colors.green[600]
            : theme.colorTokens.content.default};
        `}
`;
